import {addItemToCart, removeItemFromCart} from "./Cart";
import {querySelectCartProperty} from "./Properties";
import {getAgencyServerProjectArticlesInCart} from "../selectors/ProjectSelection";
import {getProjectSelectionForm} from "../selectors/Forms";
import {initialize as initializeForms} from "redux-form";
import {APP_MODE_AUTHENTICATED_ORDER, APP_MODE_OUTSOURCING, ARTICLE_TYPE_CMS, ARTICLE_TYPE_SHOP, OUTSOURCING_ADDPROJECT, OUTSOURCING_CREATE_NEW, PRODUCT_SELECTION_AGENCY, PRODUCT_SELECTION_CONSUMER, PROJECT_STATE_LIVE} from "../constants/General";
import {delve} from "../util/util";
import {agencyServerCMSArticles, agencyServerShopArticles, cmsArticles, shopArticles} from "../config/Config";
import {getAccounts, getArticleOptionsData} from "../selectors/SimpleSelectors";
import {getCurrentProduct, getSelectedAccount} from "../selectors/ProductSelection";
import {getAppMode} from "../selectors/Mode";
import {selectBaseArticle} from "./BaseArticle";
import {CART_QUERYPROJECT_COMPLETE, CART_QUERYPROJECT_START} from "../constants/ActionTypes";

export const queryProjectSelection = (values) => (dispatch, getState) => {

    // loop projectSelection form state and add items to cart
    return new Promise((resolve, reject) => {
        let calls = [];

        if (values && values.article) {
            calls.push(addItemToCart(values.article));
        }

        if (values && values.storage) {
            calls.push(addItemToCart(values.storage));
        }

        if (values && values.backup) {
            calls.push(querySelectCartProperty("backupRange", values.backup))
        }

        const dispatchFirstCall = (calls) => {
            dispatch(calls.shift()).then(args => {
                if (calls.length > 0) {
                    dispatchFirstCall(calls);
                } else {
                    resolve(true);
                }
            })
        }
        dispatchFirstCall(calls);
    });
}


export const queryProjectRemove = () => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        let calls = [];

        // 1: remove any articles matching agencyServerProjectArticles
        // 3: remove any article in cart being a storage option
        const articlesToRemove = getAgencyServerProjectArticlesInCart(getState())

        articlesToRemove.forEach(cartItem => {
            calls.push(removeItemFromCart(cartItem.itemId))
        })

        // 2: set backuprange on cart to false
        calls.push(querySelectCartProperty("backupRange", ""))

        const dispatchFirstCall = (calls) => {

            if (calls.length === 0) {
                resolve(true)
            } else {
                dispatch(calls.shift()).then(args => {
                    dispatchFirstCall(calls);
                })
            }

        }
        dispatchFirstCall(calls);
    });
}

export const queryAddInitialProject = (selectBase = false) => (dispatch, getState) => {
    dispatch({
        type: CART_QUERYPROJECT_START
    })
    return dispatch(queryProjectRemove()).then(args => {
        const form = getProjectSelectionForm(getState())
        if (selectBase && form && form.values && form.values.article) {
            dispatch(selectBaseArticle(form.values.article));
        }
        return dispatch(queryProjectSelection(form.values)).then(() => {
            return dispatch({
                type: CART_QUERYPROJECT_COMPLETE
            })
        })
    })
}

const findMinimumRequirementArticle = (currentProduct, possibleArticles, articleOptionsState) => {
    return possibleArticles.find((articleId) => {
        return (parseInt(delve(articleOptionsState, articleId + ".limits.visitors")) >= delve(articleOptionsState, currentProduct + ".limits.visitors"));
    }) || possibleArticles[1];
}

export const setInitialConfigurationByState = (target) => (dispatch, getState) => {

    const accounts = getAccounts(getState());
    const selectedAccount = getSelectedAccount(getState());
    const currentProduct = getCurrentProduct(getState());
    const form = getProjectSelectionForm(getState());
    const projectSettings = form ? {
        projectName: form.values && form.values.projectName,
        projectPassword: form.values && form.values.projectPassword,
        projectPasswordRepeat: form.values && form.values.projectPasswordRepeat,
    } : {};
    const mode = getAppMode();

    switch (mode) {
        case APP_MODE_OUTSOURCING:
            if (target === OUTSOURCING_CREATE_NEW) {
                dispatch(initializeForms('projectSelection',
                    {
                        article: [...cmsArticles, ...shopArticles].includes("" + currentProduct) ? currentProduct : findMinimumRequirementArticle(currentProduct, cmsArticles, getArticleOptionsData(getState())),
                        storage: "",
                        state: PROJECT_STATE_LIVE,
                        backup: delve(accounts, selectedAccount + ".backupRange") || 7,
                        type: cmsArticles.includes("" + currentProduct) ? ARTICLE_TYPE_CMS : shopArticles.includes("" + currentProduct) ? ARTICLE_TYPE_SHOP : ARTICLE_TYPE_CMS
                    }, false
                ))
            } else if (target === OUTSOURCING_ADDPROJECT) {
                dispatch(initializeForms('projectSelection',
                    {
                        article: [...agencyServerCMSArticles, ...agencyServerShopArticles].includes("" + currentProduct) ? currentProduct : findMinimumRequirementArticle(currentProduct, agencyServerCMSArticles, getArticleOptionsData(getState())),
                        storage: "",
                        state: PROJECT_STATE_LIVE,
                        backup: delve(accounts, selectedAccount + ".backupRange") || 7,
                        type: agencyServerCMSArticles.includes("" + currentProduct) ? ARTICLE_TYPE_CMS : agencyServerShopArticles.includes("" + currentProduct) ? ARTICLE_TYPE_SHOP : ARTICLE_TYPE_CMS
                    }, false
                ))
            }

            break;

        case APP_MODE_AUTHENTICATED_ORDER:

            if (target === PRODUCT_SELECTION_AGENCY) {
                dispatch(initializeForms('projectSelection',
                    {
                        article: agencyServerCMSArticles[1],
                        storage: "",
                        state: PROJECT_STATE_LIVE,
                        backup: 7,
                        type: ARTICLE_TYPE_CMS
                        , ...projectSettings
                    }, false
                ))
            } else if (target === PRODUCT_SELECTION_CONSUMER) {
                dispatch(initializeForms('projectSelection',
                    {
                        article: cmsArticles[1],
                        storage: "",
                        state: PROJECT_STATE_LIVE,
                        backup: 7,
                        type: ARTICLE_TYPE_CMS
                        , ...projectSettings
                    }, false
                ))
            }

            break;

        default:
            dispatch(initializeForms('projectSelection',
                {
                    article: agencyServerCMSArticles[1],
                    storage: "",
                    state: PROJECT_STATE_LIVE,
                    backup: delve(accounts, selectedAccount + ".backupRange") || 7,
                    type: ARTICLE_TYPE_CMS
                    , ...projectSettings
                }, false
            ))
            break;
    }

    //return dispatch(reset('projectSelection'));

}



/** WEBPACK FOOTER **
 ** ./src/actions/ProjectSelection.js
 **/